import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../../app.config';
import { Error } from '../../../shared/models/error.model';
import { RequestService } from '../../../shared/services/request.service';
import { Forecast } from './models/forecast.model';
import { ReceivableFilter } from './models/receivable-filter.model';
import { Receivable } from './models/receivable.model';

@Injectable()
export class ReceivableService {
  constructor(private requestService: RequestService) {}

  getReceivables(filter: ReceivableFilter, page: number, size: number): Promise<any> {
    return new Promise((resolve, reject) => {
      console.log(filter);
      let urlRequest: string = this.requestService.buildUrlPathParams(
        {
          startDate: filter.startDate,
          endDate: filter.endDate,

          page: page,
          size: size,
        },
        APP_CONFIG.WEBSERVICE.GET_RECEIVABLES
      );
      if (filter.storeId) {
        urlRequest += '&storeId=' + filter.storeId;
      }
      if (filter.placeId) {
        urlRequest += '&placeId=' + filter.placeId;
      }
      console.log(urlRequest);
      this.requestService.getData(urlRequest).then(
        (response: Array<any>) => {
          console.log(response);
          const receivables: Array<Receivable> = [];
          if (response && response.length > 0) {
            response.forEach((item) => {
              receivables.push(new Receivable(item));
            });
          }
          resolve(receivables);
        },
        (error: Error) => {
          console.error(error);
          reject(error);
        }
      );
    });
  }

  getForecast(storeId?: number, placeId?: number): Promise<any> {
    return new Promise((resolve, reject) => {
      let urlRequest: string = APP_CONFIG.WEBSERVICE.GET_FORECAST;
      if (storeId) {
        urlRequest += 'storeId=' + storeId;
      }
      if (placeId) {
        urlRequest += 'placeId=' + placeId;
      }
      console.log(urlRequest);
      this.requestService.getData(urlRequest).then(
        (response: Array<any>) => {
          console.log(response);
          const forecasts: Array<Forecast> = [];
          let isNextPayment: boolean = false;
          if (response && response.length > 0) {
            response.sort((a, b) =>
              a.estimatedPaymentDate > b.estimatedPaymentDate
                ? 1
                : b.estimatedPaymentDate > a.estimatedPaymentDate
                  ? -1
                  : 0
            );
            response.forEach((item) => {
              if (!isNextPayment && item.status == 'PENDING') {
                isNextPayment = true;
                item.isNextPayment = isNextPayment;
              }
              forecasts.push(new Forecast(item));
            });
          }
          if (!isNextPayment) {
            forecasts.push({
              totalToReceive: 0,
              isNextPayment: true,
            } as any);
          }
          console.log(forecasts);
          resolve(forecasts);
        },
        (error: Error) => {
          console.error(error);
          reject(error);
        }
      );
    });
  }

  getForecastDetails(placeId: number, date: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let urlRequest: string = this.requestService.buildUrlPathParams(
        {
          placeId: placeId,
          date: date,
        },
        APP_CONFIG.WEBSERVICE.GET_PLACE_FORECAST_DETAILS
      );
      this.requestService.getData(urlRequest).then(
        (response: Array<any>) => {
          console.log(response);
          resolve(response || []);
        },
        (error: Error) => {
          console.error(error);
          reject(error);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/receivables/legacy/receivables.service.ts